import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AuthGuard } from 'shared/auth/auth.guard';
import { SubscriptionGuard } from 'shared/subscription/subscription.guard';

// pages
import { InformationPageComponent } from './information-page/information-page.component';
import { CanDeactivateInformationPage } from './information-page/can-deactivate.service';
import { GlobalPageComponent } from './global-page.component';
import { FileUploaderComponent } from './file-uploader/file-uploader.component';

// page data
import { brandInfoMenuData } from './brand-information/menu-data';
import { brandInfoSegments } from './brand-information/segments-menu';
import { accountInfoMenuData } from './account-information/menu-data';
import { accountInfoSegments } from './account-information/segments-menu';

// child routes
import { brandInformationRoutes } from './brand-information/brand-information.routes';
import { accountInformationRoutes } from './account-information/account-information.routes';

import { PermissionsResolver } from 'shared/permissions/permissions.resolver';

const ROUTES = [
  {
    path: 'account-information',
    component: GlobalPageComponent,
    canActivate: [AuthGuard],
    resolve: { permissions: PermissionsResolver },
    children: [
      {
        path: '',
        // TODO: separate in other component - AccountInformationComponent
        component: InformationPageComponent,
        data: {
          menu: accountInfoMenuData,
          page: accountInfoMenuData[1],
          segments: accountInfoSegments
        },
        children: accountInformationRoutes
      },
      {
        path: 'tos',
        // TODO: separate in other component - AccountInformationComponent
        component: InformationPageComponent,
        data: {
          menu: accountInfoMenuData,
          page: accountInfoMenuData[1],
          segments: accountInfoSegments
        },
        children: accountInformationRoutes
      },
    ]
  },
  {
    path: 'global-brand-information',
    component: GlobalPageComponent,
    canActivate: [AuthGuard],
    resolve: { permissions: PermissionsResolver },
    children: [
      {
        path: '',
        // TODO: separate in other component - GlobalBrandInformationComponent
        component: InformationPageComponent,
        data: {
          menu: brandInfoMenuData,
          page: brandInfoMenuData[0],
          segments: brandInfoSegments
        },
        canActivate: [SubscriptionGuard],
        canDeactivate: [CanDeactivateInformationPage],
        children: brandInformationRoutes
      },
    ],
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(ROUTES)
  ],
  exports: [RouterModule],
  providers: [CanDeactivateInformationPage],
})
export class GlobalPagesRoutingModule { }
